"use client";

import { cn } from "@marketing-sites/utils/cn";

import { useOverlay } from "./media-player.hooks";
import { PlayButton } from "./media-player.icons";

export const Overlay = ({ playLabel }: { playLabel?: string } = {}) => {
  const { shouldHide, play, title, overlay } = useOverlay();

  return (
    <div
      aria-hidden={shouldHide}
      className={cn(
        "z-(--z-index-slot-overlay) transition-none! absolute inset-0 h-full w-full",
        shouldHide && "pointer-events-none opacity-0",
        overlay?.className,
      )}
    >
      <button
        onClick={play}
        className={cn(
          "z-(--z-index-slot-overlay) pointer-events-auto absolute inset-0 flex h-full w-full cursor-pointer items-center justify-center focus-visible:outline-2 focus-visible:outline-offset-2",
          "bg-black/20",
          "group",
          shouldHide && "pointer-events-none opacity-0",
        )}
      >
        <div className="absolute inset-0 z-10 w-full bg-black/10"></div>

        {/* Content area: title (from video context) and/or custom children */}
        {(title || overlay?.children) && (
          <div className="absolute inset-0 z-10 flex w-full flex-col items-start gap-2 p-3 lg:p-6 xl:p-8">
            {title && !overlay?.hideTitle && (
              <span className="max-w-[28ch] text-balance text-left text-lg font-medium text-white/85">
                {title}
              </span>
            )}
            {overlay?.children}
          </div>
        )}

        <PlayButton
          label={playLabel}
          className={cn(
            "absolute left-1/2 top-1/2 z-20 -translate-x-1/2 -translate-y-1/2",
            "transition-scale scale-120 ease-out-quart opacity-0 duration-500",
            "shadow-[0_9.841px_82.665px_0_rgba(0,0,0,0.75)]",
            "group-focus-visible:ring-3 group-focus-visible:ring-border-focus focus-visible:ring-3 focus-visible:ring-border-focus hover:bg-(--media-player-accent) focus-visible:bg-(--media-player-accent) group-focus-visible:bg-(--media-player-accent) pointer-events-auto hover:scale-105 focus-visible:outline-none",
            shouldHide
              ? "pointer-events-none animate-[fade-out-blur_0.66s_var(--ease-out-quart)_both]"
              : "scale-100 animate-[fade-in-blur_0.66s_var(--ease-out-quart)_both] cursor-pointer opacity-100",
          )}
        />
      </button>
    </div>
  );
};
